<template>
  <div ref="container" class="state-mods scrollbar-thin" type="none">
    <ul :style="{ '--icon-fs': `${iconFs}px`, '--icon-title-fs': `${iconTitleFs}px` }">
      <template v-for="(v, i) in mods">
        <li v-if="validHide(v.hidden)" :key="i" @click="showSensorDialog(i)">
          <div class="mods-icon">
            <ModsIcon
              :width="width"
              :icon="v.icon"
              :get-class="v.getClass"
              :wsData="curLatestWSData"
              :mods="i"
            />
          </div>
          <el-tooltip class="item" effect="dark" :content="$t(v.title)" placement="bottom">
            <span class="mods-title" :class="curLatestWSData | realState(i) | stateClass(true)">
              {{ $t(v.title) }}
            </span>
          </el-tooltip>
        </li>
      </template>
    </ul>
    <el-dialog
      v-if="sensorVisible"
      :visible="true"
      class="sensors-dialog"
      :title="$t('传感器详情')"
      width="1400px"
      top="5vh"
      :before-close="sensorClose"
    >
      <el-button
        @click="clearbBroundEvent"
        class="clear-bg"
        type="primary"
        size="small"
        v-if="authMenu['01040403']"
      >
        {{ $t('清除本底') }}
      </el-button>
      <el-tabs v-model="tabsName">
        <template v-for="(v, k) in mods">
          <el-tab-pane v-if="!v.dialogHidden" :lazy="true" :key="k" :name="k" :label="$t(v.title)">
            <template v-for="(item, key) in v.echartObj">
              <template v-if="isArray(curLatestWSData.mods[k][key])">
                <sensor-echart
                  v-for="(val, i) in curLatestWSData.mods[k][key]"
                  :key="i"
                  :use-mod="item.mod"
                  :color="v.color"
                  :echartOp="Object.assign({}, item, { title: `${item.title}${i + 1}` })"
                  :type="key"
                  :mod="k"
                  :typeIndex="i"
                />
              </template>
              <sensor-echart
                :use-mod="item.mod"
                :color="v.color"
                :echartOp="item"
                :type="key"
                :mod="k"
                :key="key"
              />
            </template>
          </el-tab-pane>
        </template>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ctt from '@/utils/const';
import ModsIcon from '@/components/mods-icon';
import { clearBground } from '@/api/devices';
import { isUndefined, isArray, includes, isString } from 'lodash';
import { getOpt, genYAxisNameOp } from '../util/mods-option';
import { addListener, removeListener } from '@/utils/dom/resize-detector';

export default {
  name: 'StateMods',
  components: {
    SensorEchart: () => import('./sensor-echart'),
    ModsIcon
  },
  filters: {
    realState(v, k) {
      if (v && v.mods && v.mods[k]) {
        const { state, runstate } = v.mods[k];
        if (runstate === ctt.RUNSTATE_FAULT) {
          return ctt.POINT_STATE_FAULT;
        } else if (runstate === ctt.RUNSTATE_FIX) {
          if (state === ctt.POINT_STATE_CONNECT) {
            return ctt.POINT_STATE_FIX;
          } else {
            return state;
          }
        } else if (runstate === ctt.RUNSTATE_NORMAL) {
          return state;
        }
      } else {
        return -1;
      }
    }
  },
  props: {
    curLatestWSData: Object,
    isHisDetail: Boolean
  },
  inject: ['getDeviceType'],
  data() {
    return {
      width: 0,
      iconFs: 60,
      iconTitleFs: 16,
      sensorVisible: false,
      tabsName: 'smokeMod',
      mods: {
        smokeMod: {
          title: '烟雾',
          icon: 'icon-fire',
          color: '#3FC5F0',
          echartObj: {
            smokeData: {
              title: '烟雾',
              markLine: 'smokeBground',
              options: getOpt({ type: 'smoke' })
            }
          }
        },
        ecMod: {
          title: '有毒有害易燃气体',
          icon: 'icon-dupin',
          color: '#6DECB9',
          echartObj: {
            hcl: {
              title: 'HCL',
              mod: 'ecMod',
              options: getOpt({ type: 'sys', op: genYAxisNameOp('PPM') })
            },
            so2: {
              title: 'SO2',
              mod: 'ecMod',
              options: getOpt({ type: 'sys', op: genYAxisNameOp('PPM') })
            },
            co: {
              title: 'CO',
              mod: 'ecMod',
              options: getOpt({ type: 'sys', op: genYAxisNameOp('PPM') })
            },
            ch4: {
              title: 'CH4',
              mod: 'ecMod',
              options: getOpt({ type: 'sys', op: genYAxisNameOp('PPM') })
            },
            pid: {
              title: 'PID',
              mod: 'ecMod',
              options: getOpt({ type: 'sys', op: genYAxisNameOp('PPM') })
            },
            ben: {
              title: '苯系物',
              mod: 'ecMod',
              options: getOpt({ type: 'sys', op: genYAxisNameOp('PPM') })
            }
          }
        },
        cwaMod: {
          title: '化学战剂',
          icon: 'icon-chemical-weapon',
          color: '#42DEE1',
          echartObj: {
            sccell1Data: { title: 'Sccell1', options: getOpt({ type: 'cwa' }) },
            sccell1RData: { title: 'Sccell1R', options: getOpt({ type: 'cwa' }) },
            sccell2Data: { title: 'Sccell2', options: getOpt({ type: 'cwa' }) },
            sccell2RData: { title: 'Sccell2R', options: getOpt({ type: 'cwa' }) }
          }
        },
        nuclearMod: {
          title: '核检测',
          icon: 'icon-he',
          color: '#728ee8',
          echartObj: {
            radDose: {
              title: '核辐射剂量（γ）',
              options: getOpt({ type: 'nuclear', op: genYAxisNameOp('uSv/h') })
            },
            'rg04Dto.alphaProbeValue': {
              title: '核辐射剂量（α）',
              options: getOpt({ type: 'nuclear', op: genYAxisNameOp('Bq/cm²') })
            },
            'rg04Dto.betaProbeValue': {
              title: '核辐射剂量（β）',
              options: getOpt({ type: 'nuclear', op: genYAxisNameOp('Bq/cm²') })
            }
          }
        },
        sysMod: {
          title: '设备状态',
          color: '#6a77af',
          icon: '',
          hidden: true,
          echartObj: {
            mainTemp: { title: '温度', options: getOpt({ type: 'sys', op: genYAxisNameOp('℃') }) },
            mainHumidity: {
              title: '湿度',
              options: getOpt({ type: 'sys', op: genYAxisNameOp('%RH') })
            },
            flow: { title: '气流', options: getOpt({ type: 'sys', op: genYAxisNameOp('L/min') }) }
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters('socket', ['singleDeviceMods'])
  },
  methods: {
    isArray,
    changeIconSize() {
      const container = this.$refs.container;

      const height = container.clientHeight - 40;

      const width = container.clientWidth / 5 - 10;

      this.width = Math.min(height, width);

      this.iconFs = this.width / 8;

      this.iconTitleFs = Math.min(this.width / 5, 16);
    },
    validHide(v) {
      const deviceType = this.getDeviceType();
      if (isUndefined(v)) return true;
      if (isArray(v)) return includes(v, deviceType);
      if (isString(v)) return v === deviceType;
      return !v;
    },
    showSensorDialog(key) {
      if (!this.isHisDetail) {
        this.sensorVisible = true;
        this.tabsName = key;
      }
    },
    sensorClose() {
      this.sensorVisible = false;
    },
    clearbBroundEvent() {
      clearBground({ sn: this.$route.params.sn, deviceType: this.getDeviceType() }).then(res => {
        if (res) {
          this.$message({
            type: 'success',
            message: '修改成功'
          });
        }
      });
    }
  },
  watch: {
    singleDeviceMods(newVal) {
      if (newVal) {
        const list = ['weatherMod', 'sysMod', 'ecMod'];

        for (let k in this.mods) {
          const hidFalg = newVal.indexOf(k) === -1;
          this.$set(this.mods[k], 'dialogHidden', hidFalg);
          if (!list.includes(k)) {
            this.$set(this.mods[k], 'hidden', hidFalg);
          }
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.changeIconSize();

      const container = this.$refs.container;

      if (!container) return;

      addListener(container, this.changeIconSize);
    });
  },
  beforeDestroy() {
    const container = this.$refs.container;

    if (!container) return;

    removeListener(container, this.changeIconSize);
  }
};
</script>

<style lang="scss">
.state-mods {
  height: 100%;
  width: 100%;
  ul {
    height: 100%;
    width: 100%;
    display: flex;
    li {
      min-width: 152px;
      max-width: 162px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-direction: column;
      cursor: pointer;

      span {
        display: inline-block;
      }
      .mods-icon {
        width: 100%;
        @include flex-center;
      }
      .mods-title {
        @include state-textstyle;

        display: inline-block;

        font-size: 16px;

        text-align: center;

        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
      }
    }
  }

  .sensors-dialog {
    .el-dialog {
      max-width: 80vw;

      .el-dialog__body {
        height: calc(90vh - 54px);
        padding: 10px 20px;

        box-sizing: border-box;

        .clear-bg {
          position: absolute;
          right: 20px;
          z-index: 9;
        }

        .el-tabs {
          height: 100%;

          .el-tabs__content {
            height: calc(100% - 55px);
            overflow: auto;
            box-sizing: border-box;
            width: 100%;

            .el-tab-pane {
              display: flex;
              flex-wrap: wrap;
              gap: 10px;

              & > * {
                width: calc(33.3% - 10px);
              }
            }

            @include scrollar-style-thin;
          }
        }
      }
    }
  }
}
</style>
